import * as React from 'react';
import * as classes from './LoadingSpinner.scss';
import spinner from '../assets/spinner.svg';
import { compact } from 'lodash';

interface Props {
  isSmall?: boolean;
}

class LoadingSpinner extends React.PureComponent<Props> {
  render() {
    const spinnerClasses = compact([
      classes.spinner,
      this.props.isSmall && classes.small,
      'loading-step-8'
    ]).join(' ');

    return (
      <div className={classes.container}>
        <img src={spinner} className={spinnerClasses} />
      </div>
    );
  }
}

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.tsx